/**
 * Generate a thumbnail (max 800px) and a compressed full-size JPEG from a File.
 * Returns both as Blobs.
 */
export async function processImage(file: File): Promise<{
  thumbnail: Blob;
  full: Blob;
  width: number;
  height: number;
}> {
  const bitmap = await createImageBitmap(file);
  const width = bitmap.width;
  const height = bitmap.height;

  // Thumbnail
  const thumbMax = 800;
  const ratio = Math.min(thumbMax / width, thumbMax / height, 1);
  const tw = Math.round(width * ratio);
  const th = Math.round(height * ratio);
  const thumbCanvas = document.createElement("canvas");
  thumbCanvas.width = tw;
  thumbCanvas.height = th;
  const tctx = thumbCanvas.getContext("2d")!;
  tctx.drawImage(bitmap, 0, 0, tw, th);
  const thumbnail = await new Promise<Blob>((resolve) =>
    thumbCanvas.toBlob((b) => resolve(b!), "image/jpeg", 0.82)!,
  );

  // Full = original file (preserve quality)
  bitmap.close();
  return { thumbnail, full: file, width, height };
}
